import { render } from "./PrescriptionModal.vue?vue&type=template&id=0aceb931&scoped=true"
import script from "./PrescriptionModal.vue?vue&type=script&lang=js"
export * from "./PrescriptionModal.vue?vue&type=script&lang=js"

import "./PrescriptionModal.vue?vue&type=style&index=0&id=0aceb931&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aceb931"]])

export default __exports__